import { render, staticRenderFns } from "./SoundSetup.vue?vue&type=template&id=6a05fd5b"
import script from "./SoundSetup.vue?vue&type=script&lang=js"
export * from "./SoundSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports